import { SpaceManagementProviders } from '_/space-management/hooks';
import { useAuth } from '_/space-management/hooks/AuthContext';
import { useSelector } from 'react-redux';
import { TopMenu } from '_/components';
import { useEffect } from 'react';
import api from '_/services/api/base';
import SpaceManagementWebView from './index.webview';
import useSpaceManagement from '_/hooks/useSpaceManagement';
import ContainerWidthLimit from '_/components/ContainerWidthLimit';
import { SpaceManagementRoutes } from '_/space-management/navigation';
import { View } from 'react-native';

const SpaceManagementApp = () => {
  const { signInInvenzi } = useAuth();
  const accessToken = (api.defaults.headers.common.authorization as string)?.split(' ')[1];
  const currentCompanyId = useSelector((state: any) => state.user.currentCompanyId);
  const spaceManagement = useSpaceManagement((state) => state.spaceManagement);

  useEffect(() => {
    signInInvenzi(accessToken);
  }, [currentCompanyId, spaceManagement?.organizationId]);

  return <SpaceManagementRoutes />;
};

export default function SpaceManagement() {
  const spaceManagement = useSpaceManagement((state) => state.spaceManagement);
  if (spaceManagement?.useWebView) return <SpaceManagementWebView />;

  return (
    <ContainerWidthLimit>
      <View style={{ flex: 1 }}>
        <TopMenu />
        <SpaceManagementProviders>
          <SpaceManagementApp />
        </SpaceManagementProviders>
      </View>
    </ContainerWidthLimit>
  );
}
